import React from 'react'
import { Label } from 'react-bootstrap'

class DocumentStatus extends React.Component {
	render() {
		var required = this.props.value.required;
        var uploaded = this.props.value.uploaded;
        var approved = this.props.value.approved;
		var label = this.props.value.label;
		let bg = '#FFFFFF';
		let type = '#000000';

		if (uploaded && approved) {
			bg = '#43d162';
			type = '#000000';
		}
		else if (uploaded && !approved) {
			bg = '#dec02c';
			type = '#000000';
		}
		else if (required && !uploaded) {
			bg = '#ba1111';
			type = '#FFFFFF';
		}

		let style = {
			backgroundColor: bg,
			color: type,
			display: "block",
			position: "relative",
			width: "100%",
			height: "34px",
			paddingTop: "10px",
			margin: "0",
			padding: "0"
		};

		return (<Label style={style}><span style={{ display: "block", paddingTop: "12px" }}>{label}</span></Label>);
	}
}

export default DocumentStatus;



// WEBPACK FOOTER //
// ./src/areas/admin/shared/DocumentStatus.js